import { useNavigate } from "@tanstack/react-router"
import { z } from "zod"

const selectionSchema = z.object({
  ids: z.array(z.string()),
  same: z.boolean(),
})

export const aircraftTypesSchema = z.record(z.string(), selectionSchema)

export type AircraftTypes = z.infer<typeof selectionSchema>

type ByItem = z.infer<typeof aircraftTypesSchema>

export const SAME_AIRCRAFT_TYPE: AircraftTypes = { ids: [], same: true }

function withAircraftTypes(
  byItem: ByItem | undefined,
  itemId: string,
  types: AircraftTypes,
): ByItem | undefined {
  const others = Object.entries(byItem ?? {}).filter(([id]) => id !== itemId)
  const isDefault = types.same && types.ids.length === 0
  const next = isDefault ? others : [...others, [itemId, types] as const]
  return next.length > 0 ? Object.fromEntries(next) : undefined
}

export function useAircraftTypes(
  byItem: ByItem | undefined,
  itemId: string,
): [AircraftTypes, (types: AircraftTypes) => void] {
  const navigate = useNavigate()
  const pick = (types: AircraftTypes) =>
    navigate({
      to: ".",
      search: (previous) => ({
        ...previous,
        aircraft_types: withAircraftTypes(byItem, itemId, types),
      }),
      replace: true,
    })
  return [byItem?.[itemId] ?? SAME_AIRCRAFT_TYPE, pick]
}
